/**
 * Suspense fallback while the Mapbox chunk downloads. Deliberately imports
 * nothing from mapbox-gl, so it stays in the main bundle and the map library
 * doesn't get pulled in just to render a placeholder.
 */
export default function MapSkeleton({ height = 400, width = "100%" }) {
  return (
    <div
      style={{
        height,
        width,
        borderRadius: 12,
        background:
          "linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 37%,#f1f5f9 63%)",
        backgroundSize: "400% 100%",
        animation: "map-skeleton 1.4s ease infinite",
      }}
    >
      <style>{`@keyframes map-skeleton { 0% { background-position: 100% 50% } 100% { background-position: 0 50% } }`}</style>
    </div>
  );
}
